import { render } from "./MailConfigIndex.vue?vue&type=template&id=526c0ca1&scoped=true"
import script from "./MailConfigIndex.vue?vue&type=script&lang=js"
export * from "./MailConfigIndex.vue?vue&type=script&lang=js"

import "./MailConfigIndex.vue?vue&type=style&index=0&id=526c0ca1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-526c0ca1"]])

export default __exports__